module.exports = __webpack_public_path__ + "media/images/cropper-logo-f7a96b206d283eae26a993c035ec5e98.png";